import React from "react";
import { getCorrectPageCount } from "../../../../utils/table.utils";
import { PlusIcon } from "@heroicons/react/24/outline";
import { ChevronFirst, ChevronLast, ChevronRight, ChevronLeft } from "lucide-react";

const Pagination = ({ server, client, table, handleFetchAll }) => {


    const correctPageCount = getCorrectPageCount(server.total, client.pageSize)

    const pageCount = correctPageCount > 0 ? correctPageCount : 1
    const hasFetchAllData = server.fetched >= server.total
    const rowCount = table.getRowCount()
    const isDisplay = pageCount > 1 || rowCount > 50

    const goLastPage = () => {
        if (handleFetchAll && !hasFetchAllData) {
            handleFetchAll()
        }
        const lastPage = table.getPageCount() - 1;
        table.setPageIndex(lastPage)
    }

    const canGoNextPage = () => {
        if (client.pageIndex < pageCount - 1) return false
        return true
    }

    const canGoPreviousPage = () => {
        if (client.pageIndex > 0) return false
        return true
    }



    if (!isDisplay) return null

    return (
        <div className="flex flex-col w-fit  gap-4">
            <div className="flex w-full flex-wrap items-center gap-3" >

                {rowCount > 1 &&
                    <select
                        value={client.pageSize}
                        onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                        }}
                        className="select select-primary select-sm select-bordered w-fit"
                    >
                        {[10, 25, 50, 100].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))}
                    </select>
                }

                {pageCount > 1 &&
                    <div className="flex items-center gap-x-2 justify-end">
                        <div className="flex gap-x-1">
                            <button
                                className="btn btn-xs"
                                onClick={() => table.setPageIndex(0)}
                                disabled={canGoPreviousPage()}
                            >
                                <ChevronFirst />
                            </button>
                            <button
                                className="btn btn-xs"
                                onClick={() => table.previousPage()}
                                disabled={canGoPreviousPage()}
                            >
                                <ChevronLeft />
                            </button>

                        </div>
                        <strong className="flex-shrink-0 text-base">
                            {client.pageIndex + 1} / {pageCount}
                        </strong>
                        <div className="flex gap-x-1">
                            <button
                                className="btn btn-xs"
                                onClick={() => table.nextPage()}
                                disabled={canGoNextPage()}
                            >
                                <ChevronRight />
                            </button>
                            <button
                                className="btn btn-xs"
                                onClick={goLastPage}
                                disabled={canGoNextPage()}
                            >
                                <ChevronLast />
                            </button>
                        </div>
                    </div>

                }
            </div>
            {
                handleFetchAll && !hasFetchAllData &&
                <div onClick={handleFetchAll} className="self-end btn w-fit btn-xs btn-primary flex group items-center  cursor-pointer hover:scale-95 transition-all">
                    <PlusIcon className=" text-white w-6 h-6" />
                    <p className="text-xs">Chargés {server.fetched} / {server.total}</p>
                </div>
            }
        </div>
    );
};

export default Pagination;
